import type { Action, PieceAction, PieceType, Team, WinReason } from '@halvard/rules';
import { z } from 'zod';
import type { Equals } from './types.js';

const coordinate = z.number().int().min(0).max(8);
const pieceId = z.string().regex(/^[A-Za-z0-9_-]{1,16}$/);

export const TeamSchema = z.enum(['I', 'B']);
export const PieceTypeSchema = z.enum(['B', 'C', 'X', 'L', 'M']);
export const WinReasonSchema = z.enum([
  'capture',
  'summit',
  'stuck',
  'resign',
  'timeout',
  'agreement',
  'repetition',
  'move-limit',
]);

export const PieceIdSchema = pieceId;

/** Game ids are URL-safe so they can appear in `/play/:gameId`. */
export const GameIdSchema = z.string().regex(/^[A-Za-z0-9_-]{6,32}$/);

export const ActionSchema = z.discriminatedUnion('kind', [
  z.object({ kind: z.literal('move'), r: coordinate, c: coordinate }).strict(),
  z.object({ kind: z.literal('capture'), r: coordinate, c: coordinate, target: pieceId }).strict(),
  z.object({ kind: z.literal('pin'), r: coordinate, c: coordinate, pin: pieceId }).strict(),
  z
    .object({
      kind: z.literal('build'),
      r: coordinate,
      c: coordinate,
      delta: z.union([z.literal(1), z.literal(-1)]),
    })
    .strict(),
]);

export const PieceActionSchema = z.object({ pieceId, action: ActionSchema }).strict();

// The schemas must describe exactly the types of the rules package.
export const schemaMatchesRules: [
  Equals<z.infer<typeof TeamSchema>, Team>,
  Equals<z.infer<typeof PieceTypeSchema>, PieceType>,
  Equals<z.infer<typeof WinReasonSchema>, WinReason>,
  Equals<z.infer<typeof ActionSchema>, Action>,
  Equals<z.infer<typeof PieceActionSchema>, PieceAction>,
] = [true, true, true, true, true];
